import bbtNative from '@bbtfe/native';
import queryString from 'utils/query-string';
import { history } from 'core/history';
import {
  QUERY_KEY_WHITE_MAP,
  NEWVIEW_QUERY_KEY_WHITE_MAP,
  NEW_WEBVIEW_QUERY
} from './config';

let isOpeningWebview = false;

export const navTo = function(config = {}) {
  let {
    url = '',
    title = '',
    webviewFirst = true,
    queryKeyBlackMap = {}
  } = config;
  if (!url) return;
  const splitedUrl = url.split('#');
  url = splitedUrl[0];
  const hash = splitedUrl[1];
  const currentUrlObj = queryString.parseUrl(window.location.href);
  const distUrlObj = queryString.parseUrl(url);
  if (webviewFirst && bbtNative.isApp()) {
    if (isOpeningWebview) return;
    isOpeningWebview = true;
    window.setTimeout(() => {
      isOpeningWebview = false;
    }, 1000);
    bbtNative.ready(() => {
      const passThrough = Object.keys(currentUrlObj.query).reduce(
        (total = {}, item) => {
          if (NEWVIEW_QUERY_KEY_WHITE_MAP[item] && !queryKeyBlackMap[item]) {
            total[`${item  }`] = currentUrlObj.query[`${item  }`];
          }
          return total;
        },
        {}
      );
      distUrlObj.query = {
        ...passThrough,
        ...distUrlObj.query
      };
      distUrlObj.query[NEW_WEBVIEW_QUERY] = 1;
      const isFullHttp = /^(\S)+:\/\/(\S)+/.test(distUrlObj.url);
      const isProtocokLessHttp = /^\/\/(\S)+/.test(distUrlObj.url);
      if (isFullHttp) {
        bbtNative.openWebview(
          title,
          `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${  hash}` : ''}`
        );
      } else if (isProtocokLessHttp) {
        bbtNative.openWebview(
          title,
          `${window.location.protocol}${queryString.stringifyUrl(distUrlObj)}${
            hash ? `#${  hash}` : ''
          }`
        );
      } else {
        bbtNative.openWebview(
          title,
          `${window.location.origin}${queryString.stringifyUrl(distUrlObj)}${
            hash ? `#${  hash}` : ''
          }`
        );
      }
    });
  } else {
    const passThrough = Object.keys(currentUrlObj.query).reduce(
      (total = {}, item) => {
        if (QUERY_KEY_WHITE_MAP[item]) {
          total[`${item  }`] = currentUrlObj.query[`${item  }`];
        }
        return total;
      },
      {}
    );
    distUrlObj.query = {
      ...passThrough,
      ...distUrlObj.query
    };
    delete distUrlObj.query[NEW_WEBVIEW_QUERY];
    const isFullHttp = /^(\S)+:\/\/(\S)+/.test(distUrlObj.url);
    const isProtocokLessHttp = /^\/\/(\S)+/.test(distUrlObj.url);
    if (isFullHttp || isProtocokLessHttp) {
      window.location.href = `${queryString.stringifyUrl(distUrlObj)}${
        hash ? `#${  hash}` : ''
      }`;
    } else {
      history.push(
        `${queryString.stringifyUrl(distUrlObj)}${hash ? `#${  hash}` : ''}`
      );
    }
  }
};

export const navBack = function() {
  const currentUrlObj = queryString.parseUrl(window.location.href);
  if (
    bbtNative.isApp() &&
    (currentUrlObj.query[NEW_WEBVIEW_QUERY] == 1 || history.length == 1)
  ) {
    bbtNative.ready(() => {
      bbtNative.closeWebview();
    });
  } else {
    history.goBack();
  }
};
